module.exports = __webpack_public_path__ + "8a066cc8847911fb5b38ac666809dfc3.pdf";